import  Comunidad  from "./comunidad";
import Entity from '../entity'

export default class Provincia extends Entity<number> {
    nombre: string;
    tipo: string;
    comunidadId: number;
    comunidad: Comunidad;
}